import { render, staticRenderFns } from "./Heading3.vue?vue&type=template&id=67bc5a25&scoped=true&"
import script from "./Heading3.vue?vue&type=script&lang=ts&"
export * from "./Heading3.vue?vue&type=script&lang=ts&"
import style0 from "./Heading3.vue?vue&type=style&index=0&id=67bc5a25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bc5a25",
  null
  
)

export default component.exports